export default {
    LAO_GET_EXPORT_CHART_SUCCESS: "LAO_GET_EXPORT_CHART_SUCCESS",
    LAO_GET_EXPORT_CHART_FAILED: "LAO_GET_EXPORT_CHART_FAILED",
    LAO_CHARTS_LOADING: "LAO_CHARTS_LOADING",
}